import type { Money } from '@dastarhan/contracts';

/** Номиналы купюр Казахстана в тиынах. */
const KZT_NOTES: Money[] = [500_00, 1000_00, 2000_00, 5000_00, 10000_00, 20000_00];

/**
 * Быстрые кнопки «Получено» для наличных. Сначала бытовые округления
 * (на чек 3 700 гость протягивает 4 000 двумя двухтысячными, а не десятку),
 * затем ближайшие купюры. Ровно 4 кнопки, без дублей, первая — «без сдачи».
 */
export function quickTenderOptions(due: Money): Money[] {
  const out: Money[] = [due];
  for (const step of [100_00, 500_00, 1000_00]) {
    const v = Math.ceil(due / step) * step;
    if (v > due && !out.includes(v)) out.push(v);
    if (out.length >= 4) return out;
  }
  for (const n of KZT_NOTES) {
    if (n >= due && !out.includes(n)) out.push(n);
    if (out.length >= 4) return out;
  }
  let v = Math.ceil(due / 10000_00) * 10000_00;
  while (out.length < 4) {
    if (!out.includes(v)) out.push(v);
    v += 10000_00;
  }
  return out;
}
